import { useEffect } from "react";
import {
  Banner,
  Description,
  Footer,
  Goods,
  Header,
  News,
  StillPhotos,
  Synopsys,
  Trailer,
} from "./components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/sakura.css";
import styled from "styled-components";
import { sakura } from "./utils/sakura";
import { Z_INDEX } from "./constants/zIndex";
import smoothscroll from "smoothscroll-polyfill";

function App() {
  useEffect(() => {
    smoothscroll.polyfill();

    const sakurObj = sakura("#sakura-petals");

    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--nav-height",
      `${window.innerHeight}px`
    );

    window.onbeforeunload = function () {
      window.scrollTo({
        top: 0,
        left: 0,
      });
    };

    document.onvisibilitychange = function () {
      if (document.visibilityState === "hidden") {
        sakurObj.stop();
      } else {
        sakurObj.start();
      }
    };

    window.addEventListener("resize", () => {
      document.documentElement.style.setProperty(
        "--nav-height",
        `${window.innerHeight}px`
      );
    });
  }, []);

  return (
    <Wrapper id="content">
      <Header />
      <Synopsys />
      <Trailer />
      <Description />
      <StillPhotos />
      <Banner />
      <News />
      <Goods />
      <Footer />
      <SakuraWrapper id="sakura-petals" />
    </Wrapper>
  );
}

export default App;

const Wrapper = styled.div`
  height: calc(var(--nav-height, 1vh));

  > div:not(#sakura-petals) {
    position: relative;
    z-index: ${Z_INDEX.CONTENT};
  }
`;

const SakuraWrapper = styled.div`
  position: fixed;
  top: -100px;
  left: 0;
  width: calc(100vw + 100px);
  height: calc(var(--app-height, 1vh) + 100px);
  z-index: ${Z_INDEX.PETAL};
  pointer-events: none;
`;
